import app from "../_app";
import {adpObserver} from "./adp";

const priceToggle = document.querySelector('.js-price-toggle');

export let updatePrices;

if(priceToggle) {
    let showPricesExcl = +localStorage.getItem('showPricesExcl');

    updatePrices = () => {
        const prices = [...document.querySelectorAll('.js-price')];

        prices.map(price => {
            if(showPricesExcl) {
                price.innerText = app.currency(price.dataset.price / 1.21);
            } else {
                price.innerText = app.currency(price.dataset.price);
            }
        })

        return showPricesExcl;
    };

    const togglePricesHandler = ({currentTarget: {checked}}) => {
        showPricesExcl = +checked;
        localStorage.setItem('showPricesExcl', showPricesExcl);

        updatePrices();

        const productForm = document.querySelector('.js-product-form');

        if(productForm) {
            const productPrice = productForm.querySelector('.js-product-price');

            if (window.appikon && window.appikon.product && window.appikonDiscount && window.appikonDiscount.loadProductPageApi) {
                adpObserver.observe(productForm, {childList: true});

                window.appikon.product.variant_price = showPricesExcl ? productPrice.dataset.price / 1.21 : productPrice.dataset.price;
                window.appikonDiscount.loadProductPageApi();
            }
        }
    };

    if(showPricesExcl) {
        priceToggle.checked = true;
        updatePrices();
    }

    priceToggle.addEventListener('click', togglePricesHandler);
}
